<template>
<div >
    <p class="title">操作视频</p>
    <div>
       <video src="../assets/jd.mp4" type='video/mp4' controls="controls" width="100%" height='500px' style='border:1px solid #ddd;'>
       您的浏览器不支持 video 标签.
       </video>
    </div>
</div>
</template>
<script>
export default {
    name:'center',
    data(){
        return{
            
        }

    }
}
</script>
<style>

</style>